
import type { ExtractPropTypes, PropType } from 'vue'
import type _CalendarPanel from './calendar-panel.vue'

export const sdCalendarPanelProps = {
    date           : { type: Date                                           , required: true    },
    today          : { type: String                                         , default: ''       },
    firstDayOfWeek : { type: Number                                         , default: 1        },
    onlyShowCurrent: { type: Boolean                                        , default: true     }, 
    selectedDay    : { type: [String, Array] as PropType<string | string[]> , default: () => '' },
    cellStyle      : { type: Function                                                           }
} as const

export type SdCalendarProps         = ExtractPropTypes<typeof sdCalendarPanelProps>
export type SdCalendarPanelInstance = InstanceType<typeof _CalendarPanel>


